<template>
  <div class="input-content">
    <span class="input-text input-text-left">{{ detail.fieldName }}</span>
    <span class="input-text">{{ fieldData.fieldValue }}</span>
  </div>
</template>

<script>
import http from "@/utils/request";
import { qmsUrl } from "@/config";
// 获取字段详情
export const apiPostFiledDetail = (params = {}) =>
  http.post(`${qmsUrl}/qms-service/api/standard/v2/field/detail`, params);
export default {
  name: "CardFieldInput",
  data() {
    return {
      detail: {}
    };
  },
  props: {
    fieldData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.getDetail();
  },
  components: {},
  computed: {},
  watch: {},
  methods: {
    async getDetail() {
      const params = { id: this.fieldData.fieldId };
      const resp = await apiPostFiledDetail(params);
      if (resp.error) return;
      this.detail = resp.datas;
    }
  }
};
</script>
<style lang="less">
.input-content {
  padding-top: 8px;
  padding-bottom: 8px;
}
.input-text {
  padding-right: 15px;
  font-size: 14px;
}
.input-text-left {
  color: #969799;
}
</style>
